import { render, staticRenderFns } from "./EditCampaign.vue?vue&type=template&id=64030263&scoped=true&"
import script from "./EditCampaign.vue?vue&type=script&lang=js&"
export * from "./EditCampaign.vue?vue&type=script&lang=js&"
import style0 from "./EditCampaign.vue?vue&type=style&index=0&id=64030263&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64030263",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64030263')) {
      api.createRecord('64030263', component.options)
    } else {
      api.reload('64030263', component.options)
    }
    module.hot.accept("./EditCampaign.vue?vue&type=template&id=64030263&scoped=true&", function () {
      api.rerender('64030263', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/settings/campaigns/EditCampaign.vue"
export default component.exports